import TenantForm from "../MyTenant/TenantForm"

type Props = {
  heroImage: string
}

const MyCompanyPageContent = ({ heroImage }: Props) => {
  return <TenantForm heroImage={heroImage} isMyCompanyPage />
}

export default MyCompanyPageContent